<!-- Copyright (c) 2020-2021 ForgeRock. All rights reserved.

This software may be modified and distributed under the terms
of the MIT license. See the LICENSE file for details. -->
<template>
  <div>
    
    <FrListGroup  :title="this.$t('pages.workflow.unassignedTasks')">
      <FrSearchInput
        style = "margin-left: auto;margin-right :24px; width: 500px"
        v-model="filter"
        :placeholder="$t('common.search')"
        @clear="clear"
        @search ="search" 
        />
        <!-- @search =" () => $emit('search')"  -->
<!-- @search="search" -->
      <div :key="testData" class="card-body">
      <template v-if="!isEmpty(pageOfItems)">
        <TransitionGroup
          name="fade"
          mode="out-in">
          <FrListItem
            :collapsible="true"
            v-for="(item) in pageOfItems"
            :key="`groupTask_${item.id}`"
            :ref="`collapse-${item.id}`"
            @shown="setShown(item.id)"
            @hidden="setHidden(item.id)">
             <div
              slot="list-item-header"
              class="d-inline-flex w-100 media">
              <div class="media-body align-self-center">
                <h6 class="mb-1 mt-0">
                  {{ item.name[0].name }} 
                </h6>
                <small class="text-muted d-block mb-2">
                  {{ $t('pages.workflow.notAssigned') }}
                </small>
              </div>
              <div class="d-flex mb-3 ml-3 align-self-center">
                <BButton
                  v-if="panelShown[item.id] === true"
                  variant="link"
                  size="sm"
                  class="btn-cancel mb-2"
                  :ref="`cancel-${item.id}`">
                  {{ $t('common.cancel') }}
                </BButton>
                <BButton
                  v-else
                  variant="link"
                  size="sm"
                  class="btn-edit">
                  {{ $t('pages.workflow.assign') }}
                </BButton>
              </div>
            </div> 
            <div
              slot="list-item-collapse-body"
              class="d-inline-flex w-100">
              <FrAssignTask
                :shown="panelShown[item.id]"
                :task-definition="item.name[0]"
                @loadProcess="(process) => $emit('loadProcess', process)"
                @assignTask="assignTask" /> 
            </div>
          </FrListItem>
        </TransitionGroup>
      </template>
      <FrListItem v-else>
        <div
          slot="list-item-header"
          class="text-muted text-center w-100">
          {{ $t('pages.workflow.noGroupTasks') }}
        </div>
      </FrListItem>
    </div> 
          <div class="card-footer text-center pb-0 pt-3">
            <div>
              <jw-pagination :key="value" :items="objectToArray" :pageSize="value" :initialPage=1 @changePage="onChangePage"></jw-pagination>
            </div>
            <div>
              <span style="color:#69788B">Items to display:</span>
              <select class="selectStyles" v-model="selectedOption" @change="reload(selectedOption)">
                <option value="5"><span>5 per page</span></option>
                <option value="10"><span>10 per page</span></option>
                <option value="20"><span>20 per page</span></option>
                <option value="50"><span>50 per page</span></option>
                <option value="100"><span>100 per page</span></option>
              </select>
              <!-- <input 
              class="inputPaginationStyles"
              type="select" @change="reload" v-model="value"> -->
            </div>
          </div>
    </FrListGroup>
  </div>
</template>

<script>
import {
  isFunction, isEmpty, keys, difference, first, isUndefined,
} from 'lodash';
import { mapState, mapActions } from 'vuex';
import FrListGroup from '@forgerock/platform-shared/src/components/ListGroup/';
import FrListItem from '@forgerock/platform-shared/src/components/ListItem/';
import FrAssignTask from '../AssignTask';
import FrSearchInput from '@forgerock/platform-shared/src/components/SearchInput';

/**
 * @description Dashboard widget that lists available group tasks that can be assigned
 *
 * */
export default {
  name: 'GroupTasks',
  props: {
    tasks: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    console.log("===>",this.tasks)
    return { 
      panelShown: {}, 
      onHidden: null, 
      pageOfItems: [], 
      testData:0,
      value: 10, 
      selectedOption: '10',
      filter: '',
      copiedTasks : {}, //shallow copy of what I get from tasks props
    };
    
  },
  components: {
    FrListGroup,
    FrListItem,
    FrAssignTask,
    FrSearchInput,
  },
  beforeCreate(){
    try{
      if(!!this.tasks)
      this.copiedTasks = Object.assign({},this.tasks)
    } catch (err) {
      console.log("Somethign Went Wrong : " + err)
    }
  },
  methods: {
    isEmpty,
    first,
    ...mapActions(['enableButton']),
    clear() {
      this.copiedTasks = {...this.tasks};
      this.testData++
    },
    search(){
      this.searchString = this.filter
      if (!!this.searchString){
        this.submitBeforeLengthValid = false;
        this.copiedTasks = Object.entries(this.tasks)
                      .filter(([key, value]) => (value.name).toLowerCase().includes(this.searchString.toLowerCase()))
                      .reduce((obj, [key, value]) => {
                          obj[key] = value;
                          return obj;
                      }, {});
        this.testData++
      } else {
        this.copiedTasks = {...this.tasks};
        this.testData++
      }
    },
    reload(selectedValue){
      this.value = parseInt(selectedValue)
      this.testData++
    },
    setShown(id) {
      this.$set(this.panelShown, id, true);
    },
    setHidden(id) {
      this.$set(this.panelShown, id, false);

      if (isFunction(this.onHidden)) {
        this.onHidden();
        this.onHidden = null;
      }
    },
    onChangePage(pageOfItems) {
      // update page of items
      this.pageOfItems = pageOfItems;
    },
    cancel(id) {
      first(this.$refs[`cancel-${id}`]).click();
    },
    assignTask({ id, assignee }) {
      this.$store.commit('enableButton');
      const { task } = this.tasks[id];

      // this.onHidden = () => {
        this.$emit('updateAssignment', { assignee, id, task });
        
      // };
      
    },
  },
  computed: {
    
    //vuex state variable button to enable and disable the bulk approval and reject buttons.
    ...mapState(['buttonDisabled']),

    objectToArray() {
      if(Object.keys(this.copiedTasks).length === 0 && !this.filter){
        var arrayValueOfObject = Object.entries(this.tasks).map((e) => ({ [e[0]]: e[1] }))
      }  else {
        // if (Object.keys(this.copiedTasks).length === 0){
        //   this.copiedTasks = {...this.tasks};
        // }
        var arrayValueOfObject = Object.entries(this.copiedTasks).map((e) => ({ [e[0]]: e[1] }))
      }
      var finalArray = []
      arrayValueOfObject.forEach((value, index) => {
        var indexValue = Object.keys(value)
        console.log(indexValue.join())
        finalArray.push({ id: indexValue.join(), name: Object.values(value) })
      })
      return finalArray;
    }
  },
  watch: {
    tasks: {
      /**
        * This function sets the state of panelShown. Anytime new tasks are added to the tasks prop,
        * the prop key is added to the panelShown object with an initial state of `false`.
        */
      handler(val, oldVal) {
        const newVals = difference(keys(val), keys(oldVal));

        if (isUndefined(this.panelShown)) {
          this.panelShown = {};
        }
        this.search()
        //this.objectToArray()

        newVals.forEach((panelValue) => {
          this.$set(this.panelShown, panelValue, false);
        });
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
.selectStyles{
  border-top:unset;
  border-left:unset;
  border-right:unset;
  border-bottom:0.25px solid #324054;
  padding-top : 8px;
  padding-bottom : 8px;
  padding-left : 8px;
  margin-bottom:10px;
  color:#324054
}
.selectStyles:hover,.selectStyles:active{
  border-top:unset;
  border-left:unset;
  border-right:unset;
  padding-top : 8px;
  padding-bottom : 8px;
  padding-left : 8px;
  border-bottom : 3px solid #000;
  margin-bottom:10px;
  color:#000
}

select > option > span {
  background-color: #fff;
  color: #69788B;
  padding: 10px;
}

.multiselectCheckboxStyle{
  height: 20px ;
  margin-top:30px;
  border :unset !important;
  outline: none !important;
}

</style>>
